import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './LoadingFonts.scss';
import './LoadingDinPro.scss';
import './utils/fontawesome.js';
import { BrowserRouter as Router } from 'react-router-dom';

// import Projects from 'Components/Projects/Projects';
// import NewsUpdates from 'Components/LandingPage/NewsUpdates/NewsUpdates';

import RoutingManager from 'Components/RoutingManager/RoutingManager';
import PageBody from './components/Layout/PageBody/PageBody';

function App() {
  useEffect(() => {
    // Handle initial load with hash
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.getElementById(window.location.hash.slice(1));
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 100,
            behavior: 'smooth',
          });
        }
      }, 100);
    }
  }, []);

  return (
    <Router>
      {/* Test */}
      <div className="App">
        <PageBody>
          <RoutingManager />
        </PageBody>
      </div>
    </Router>
  );
}

export default App;
